import $ from 'jquery';
/**
 * deliveryInfoV3 widget configs
 */
const deliveryInfoV3Semantics = {
    'mainWrapClass': 'delivery-info-v3',
    'containerClass': 'delivery-info-v3__container',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'eventElement': '.delivery-info-v3__options form',
    'attrTabSwitcher': 'data-for-option-name',
    'additionalElementClass': 'delivery-info-v3__additional'
};

/**
 * deliveryInfoV3 initializer
 * //mvp use old script
 */
$(function () {
    //deliveryInfoV3.init();
 let roots = $(`.${deliveryInfoV3Semantics.mainWrapClass}`);
    if (roots.length === 0) {
        return false;
    }
    let deliveryInfoV3 = new DeliveryInfoV3();
    /**
     * Checking other instances
     */
    roots.each((index, el) => {
        let isInitialized =
            ($(el).attr(`${deliveryInfoV3Semantics.isInitializedAttribute}`) === 'true');

        if (!isInitialized) {
            deliveryInfoV3.registerInstance($(el));
            deliveryInfoV3.registerListeners($(el));
        }
    });
});

class DeliveryInfoV3 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${deliveryInfoV3Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.deliveryInfoV3) {
            window.widgets.deliveryInfoV3 = new DeliveryInfoV3();
        }

        /**
         * Checking other instances
         */
        $(`.${deliveryInfoV3Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${deliveryInfoV3Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.deliveryInfoV3.registerInstance($(el));
                window.widgets.deliveryInfoV3.registerListeners($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${deliveryInfoV3Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${deliveryInfoV3Semantics.mainWrapClass}`);
            el.attr(`${deliveryInfoV3Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${deliveryInfoV3Semantics.mainWrapClass}[${
                deliveryInfoV3Semantics
                        .instanceIdAttribute
        }="${
                el.attr(deliveryInfoV3Semantics
                        .instanceIdAttribute)
        }"]`);

        elements.find(`.${deliveryInfoV3Semantics.containerClass}`).each((index,value) => {
            let container = $(value);
            container.on(
            'change',
            deliveryInfoV3Semantics.eventElement,
            (e) => {
                e.preventDefault();
                let current = $(e.target);
                let selector = `[${deliveryInfoV3Semantics.attrTabSwitcher}="${current.val()}"]`;
                container.find(`.${deliveryInfoV3Semantics.additionalElementClass}`).children().hide();
                container.find(selector).show().siblings().hide();
            }
        )
        });
    }

    reInit(instanceId) {
        DeliveryInfoV3.init();
    }
}